import React, {useEffect, useState} from "react";
import {useFormErrors} from "../../features/formErrors/formErrors";
import toast from "react-hot-toast";
import {useLoading} from "../../context/LoadingContext";
import {LateGroupJoinModel} from "../../features/lateGroup/lateGroupTypes";
import {useFetchLateGroups, useJoinLateGroup} from "../../features/lateGroup/lateGroupApi";
import BackLink from "../Nav/BackLink";
import {useFetchCurrentRound} from "../../features/round/roundApi";
import {useNavigate} from "react-router-dom";


const LateGroupForm = () => {
    const {data:round, isLoading} = useFetchCurrentRound();
    const {data:lateGroups} = useFetchLateGroups(round?.id ?? 0);
    const { mutate: joinlateGroup } = useJoinLateGroup();
    const [ formData, setFormData] = useState<LateGroupJoinModel | null>(null);
    const { handleError, clearErrors, renderError } = useFormErrors();
    const { setLoading } = useLoading();
    const navigate = useNavigate();

    useEffect(() => {
        if (round) {
            setFormData({
                day: 'monday',
                round_id: round.id
            });
        }
    }, [round]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { id, value } = e.target;
        if (formData) {
            setFormData({ ...formData, [id]: value });
        }
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        if (formData && round) {
            joinlateGroup({...formData}, {
                onError: (error) => {
                    toast.error('Error occured');
                    handleError(error);
                },
                onSuccess: () => {
                    toast.success('Joined late group');
                    clearErrors();
                },
                onSettled: () => {
                    setLoading(false);
                }
            });
        }
    };

    const days = [
        { value: 'monday', label: 'Monday' },
        { value: 'tuesday', label: 'Tuesday' }
    ]

    return (
        <>
            {(!isLoading && (!round || !formData)) &&
                <div className="panel bg-secondary">
                    <div className="row g-0 align-items-center">
                        <div className="col-lg-6">
                            <img className="img-fluid" src="/sunset.jpg" alt="sunset"/>
                        </div>
                        <div className="col-lg-6">
                            <div className="p-2">
                                <h3 className="mb-0 mt-md-0">LATE GROUP IS CLOSED</h3>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {round && formData &&
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-12">
                            <BackLink to={`/season/${round.event.slug}`} label={'Go back to season'}/>
                        </div>
                    </div>
                    <div className="panel bg-secondary">
                        <div className="row g-0">
                            <div className="col-lg-6">
                                <img className="img-fluid" src="/sunset.jpg" alt="sunset"/>
                            </div>
                            <div className="col-lg-6">
                                <div className="p-2">
                                    <h3 className="mb-0 mt-md-0">JOIN LATE GROUP</h3>
                                    <h4 className="mt-0 mb-3"><b>{round.name}</b></h4>

                                    <div className='form-group mt-2'>
                                        <label className="form-label">SELECT QUALIFYING DAY</label>
                                        <select
                                            className="form-select"
                                            id="day"
                                            value={formData.day}
                                            onChange={handleChange}
                                        >
                                            {days.map((day) => (
                                                <option key={day.value} value={day.value}>{day.label}</option>
                                            ))}
                                        </select>
                                        {renderError("day")}

                                        <button type="submit" className="btn btn-primary mt-1">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            }

            {lateGroups && Object.keys(lateGroups).length > 0 &&
                <div className='card text-white bg-secondary'>
                    <div className='card-body p-2'>
                        {Object.keys(lateGroups).map((day) => (
                            <>
                                <h2 className='mt-0'>{day}</h2>
                                <div className='row'>
                                    {Object.keys(lateGroups[day]).map((group) => (
                                        <div className='col-md-4 mb-3'>
                                            <strong>
                                                GROUP {group}
                                            </strong>
                                            {lateGroups[day][group].map((driver) => (
                                                <p className='mb-0'>{driver.name}</p>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </>
                        ))}
                    </div>
                </div>
            }
        </>
    );
};

export default LateGroupForm;
